export function formatDateTime(input) {
    if (!input) return '-'
    const d = new Date(input)
    if (isNaN(d.getTime())) return String(input)
    const y = d.getFullYear()
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')
    const hh = String(d.getHours()).padStart(2, '0')
    const mi = String(d.getMinutes()).padStart(2, '0')
    const ss = String(d.getSeconds()).padStart(2, '0')
    return `${y}-${mm}-${dd} ${hh}:${mi}:${ss}`
}

export const APP_DISPLAY_TIME_ZONE = 'Asia/Seoul'

function formatDateTimePartsInTimeZone(input, timeZone, withSeconds = false) {
    if (!input) return '-'
    const d = new Date(input)
    if (Number.isNaN(d.getTime())) return String(input)
    const parts = Object.fromEntries(
        new Intl.DateTimeFormat('en-GB', {
            timeZone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: withSeconds ? '2-digit' : undefined,
            hour12: false,
        }).formatToParts(d).map((part) => [part.type, part.value]),
    )
    const base = `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}`
    return withSeconds ? `${base}:${parts.second}` : base
}

export function formatDateTimeMinuteInTimeZone(input, timeZone = APP_DISPLAY_TIME_ZONE) {
    return formatDateTimePartsInTimeZone(input, timeZone, false)
}

export function formatDateTimeMinuteKst(input) {
    return formatDateTimeMinuteInTimeZone(input, APP_DISPLAY_TIME_ZONE)
}

/** API `*Display` 필드 우선, 없으면 Instant를 KST로 포맷 */
export function formatApiDateTimeDisplay(display, fallbackInstant) {
    const displayText = display == null ? '' : String(display).trim()
    if (displayText) return displayText
    return formatDateTimeMinuteKst(fallbackInstant)
}

/** 목록/상세 row에서 `{field}Display` + `{field}` 조합 포맷 */
export function formatMenuInstant(record, field) {
    if (!record || !field) return '-'
    return formatApiDateTimeDisplay(record[`${field}Display`], record[field])
}

export function formatDateTimeMinute(input) {
    if (!input) return '-'
    const d = new Date(input)
    if (Number.isNaN(d.getTime())) return String(input)
    return formatDateTimeMinuteKst(input)
}

export function formatDate(input) {
    if (!input) return '-'
    const d = new Date(input)
    if (Number.isNaN(d.getTime())) return String(input)
    const parts = Object.fromEntries(
        new Intl.DateTimeFormat('en-GB', {
            timeZone: APP_DISPLAY_TIME_ZONE,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        }).formatToParts(d).map((part) => [part.type, part.value]),
    )
    return `${parts.year}-${parts.month}-${parts.day}`
}
